import {config, aceCustId, platform, apiUrl} from '../context/context';
import redirectUtils from '../utils/redirect-utils';
import acerillRestErrorHandler from '../infrastructure/acerill/acerill-rest-error-handler';

const redirectToLoginUrl = (redirectKey, extraScopes) => {
  const url = platform === 'SHOPIFY' ?
    apiUrl + '/authentication/v2/login/custom-forms?shop=' + encodeURIComponent(aceCustId) +
      (redirectKey ? '&redirect_key=' + encodeURIComponent(redirectKey) : '') +
      (extraScopes && extraScopes.length > 0 ? '&extra_scopes=' + encodeURIComponent(extraScopes.join(',')) : '') :
    config.loginUrl;
  return redirectUtils.redirectTo(url);
};

acerillRestErrorHandler.setUnauthorizedErrorInterceptor(() => {
  const redirectKey = (window.location.pathname || '').indexOf('/billing/plans') === 0 ?
    'billing_plans' :
    null;
  return redirectToLoginUrl(redirectKey);
});

const authenticationService = {
  redirectToLoginUrl,
};

export default authenticationService;
